import { inject, Injectable } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';
import { map, Observable, of, take } from 'rxjs';

import { ConfirmationDialogComponent } from '@bn/web-ui/dialog';

@Injectable({ providedIn: 'root' })
export class ImpersonationConfirmService {
  private readonly dialog = inject(BsModalService);

  /** Asks the partner to confirm impersonation. Emits once: true on confirm, false on cancel. */
  public confirm(customerLabel?: string | null): Observable<boolean> {
    const target = customerLabel ? `<strong>${customerLabel}</strong>` : 'this customer';
    const modalRef = this.dialog.show(ConfirmationDialogComponent, {
      class: 'modal-dialog-centered modal-sm',
      initialState: {
        data: {
          contextType: 'info',
          confirmButtonName: 'Impersonate',
          title: 'Impersonate customer',
          description: `You'll be logged in to the bunny.net dashboard as ${target} in a new tab.`,
          event: { action: 'confirm' },
          textCenter: true,
        },
      },
    });

    if (!modalRef.content) {
      return of(false);
    }

    return modalRef.content.getOnAction$().pipe(
      take(1),
      map((event) => {
        if (event.action !== 'confirm') {
          modalRef.hide();
          return false;
        }
        return true;
      }),
    );
  }
}
